import CatalogCollection from 'bundles/catalogP/models/catalogCollection';
import CourseProgress from 'bundles/in-course-stores/models/courseProgress';

const CourseProgressCollection = CatalogCollection.extend({
  model: CourseProgress,
  resourceName: 'onDemandCoursesProgress.v1',
});

export default CourseProgressCollection;
